export default __webpack_public_path__ + "static/media/check_gray.dc4324cd.svg";